import { SelectOptionType } from '@octano/global-ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import ChipMultiSelect from '../../../../../../components/form/ChipMultiSelect';
import SectionTitle from '../../../../../../components/text/SectionTitle';

const prefix = 'tariffAndTuition.discounts';
const discountPrefix = `${prefix}.discount`;

interface SelectOptions {
  academicLevels: SelectOptionType[];
  periods: SelectOptionType[];
  studyPlans: SelectOptionType[];
  campuses: SelectOptionType[];
  schedules: SelectOptionType[];
  modalities: SelectOptionType[];
}

interface FormValues {
  hasAutomaticAssignment: boolean;
  inicioAcademicLevelIds: SelectOptionType[];
  inicioPeriodIds: SelectOptionType[];
  inicioStudyPlanIds: SelectOptionType[];
  inicioCampusIds: SelectOptionType[];
  inicioScheduleIds: SelectOptionType[];
  inicioModalityIds: SelectOptionType[];
  [key: string]: any;
}

interface DiscountInicioSectionProps {
  selectOptions: SelectOptions;
}

const DiscountInicioSection = ({
  selectOptions,
}: DiscountInicioSectionProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();

  const hasAutomaticAssignment = useWatch({
    control,
    name: 'hasAutomaticAssignment',
  });

  if (!hasAutomaticAssignment) {
    return null;
  }

  return (
    <>
      <Row className="mb-3 mt-5">
        <Col xs="12">
          <SectionTitle text={t(`${discountPrefix}.inicioParamsTitle`)} />
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="6" className="mb-3">
          <ChipMultiSelect
            name="inicioAcademicLevelIds"
            label={t(`${discountPrefix}.academicLevel`)}
            options={selectOptions.academicLevels}
            control={control}
            placeholder={t(`${discountPrefix}.selectOption`)}
            allowSelectAll
          />
        </Col>
        <Col xs="12" md="6" className="mb-3">
          <ChipMultiSelect
            name="inicioPeriodIds"
            label={t(`${discountPrefix}.admissionPeriod`)}
            options={selectOptions.periods}
            control={control}
            placeholder={t(`${discountPrefix}.selectOption`)}
            allowSelectAll
          />
        </Col>
        <Col xs="12" md="6" className="mb-3">
          <ChipMultiSelect
            name="inicioStudyPlanIds"
            label={t(`${discountPrefix}.studyPlan`)}
            options={selectOptions.studyPlans}
            control={control}
            placeholder={t(`${discountPrefix}.selectOption`)}
            allowSelectAll
          />
        </Col>
        <Col xs="12" md="6" className="mb-3">
          <ChipMultiSelect
            name="inicioCampusIds"
            label={t(`${discountPrefix}.campus`)}
            options={selectOptions.campuses}
            control={control}
            placeholder={t(`${discountPrefix}.selectOption`)}
            allowSelectAll
          />
        </Col>
        <Col xs="12" md="6" className="mb-3">
          <ChipMultiSelect
            name="inicioScheduleIds"
            label={t(`${discountPrefix}.schedule`)}
            options={selectOptions.schedules}
            control={control}
            placeholder={t(`${discountPrefix}.selectOption`)}
            allowSelectAll
          />
        </Col>
        <Col xs="12" md="6" className="mb-3">
          <ChipMultiSelect
            name="inicioModalityIds"
            label={t(`${discountPrefix}.modality`)}
            options={selectOptions.modalities}
            control={control}
            placeholder={t(`${discountPrefix}.selectOption`)}
            allowSelectAll
          />
        </Col>
      </Row>
    </>
  );
};

export default DiscountInicioSection;
